import dayjs from "dayjs";

export const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";

export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const convertToDayJs = (date: Date): dayjs.Dayjs => {
    return dayjs(date);
};

export const getDate = (daysFromNow?: number): dayjs.Dayjs => {
    let date = dayjs();

    if (daysFromNow && daysFromNow > 0) {
        date = date.add(daysFromNow, "day");
    }

    return date;
};

export const getDateFormatted = (date: dayjs.Dayjs) => {
    return date.format(DEFAULT_DATE_FORMAT);
};

export const getDateFormattedToSavedItem = (date: any) => {
    return dayjs(date).format(DEFAULT_DATE_FORMAT);
};

export const createDate = (stringDate: string): dayjs.Dayjs => {
    const date = (stringDate || "").split("+")[0];
    return dayjs(date, DEFAULT_DATE_FORMAT);
};

export const dateIsBefore = (beforeDate: string, afterDate: string) => {
    const beforeDateParsed = createDate(beforeDate);
    const afterDateParsed = createDate(afterDate);

    return beforeDateParsed.isBefore(afterDateParsed);
};

export const getDatesRange = (fromDate: string, toDate: string) => {
    const fromDateParsed = createDate(fromDate);
    const toDateParsed = createDate(toDate);
    const fromMonthParse = parseInt(fromDate[5] + fromDate[6]);
    const toMonthParse = parseInt(toDate[5] + toDate[6]);
    const fromYearParse = parseInt(fromDate[0] + fromDate[1] + fromDate[2] + fromDate[3] + fromDate[4]);
    const toYearParse = parseInt(toDate[0] + toDate[1] + toDate[2] + toDate[3] + toDate[4]);

    const monthsDiff = (toYearParse - fromYearParse) * 12 + (toMonthParse - fromMonthParse) + 1;

    const datesArr = [];
    for (let i = 0; i < monthsDiff; i++) {
        datesArr.push(getDateFormatted(fromDateParsed.add(i, "month")));
    }

    return datesArr;
};

export const getMonthNumberFromDate = (date: string) => {
    const month = date[5] + date[6];
    return parseInt(month);
};

export const getDaysNumberFromDate = (date: string) => {
    const days = date[8] + date[9];
    return parseInt(days);
};

export const getMonthFromNumber = (monthNumber: number) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    return monthNumber === 0 ? months[11] : months[(monthNumber - 1) % 12];
};

export const isAtLeastTwoMonth = (fromDate: string, toDate: string) => {
    const date1 = new Date(fromDate);
    const date2 = new Date(toDate);

    // One day in milliseconds
    const oneDay = 1000 * 60 * 60 * 24;

    // Calculating the time difference between two dates
    const diffInTime = date2.getTime() - date1.getTime();

    // Calculating the no. of days between two dates
    const diffInDays = Math.round(diffInTime / oneDay);

    return diffInDays >= 58;
};

export const isMaxTwelve = (fromDate: string, toDate: string) => {
    const date1 = new Date(fromDate);
    const date2 = new Date(toDate);

    // One day in milliseconds
    const oneDay = 1000 * 60 * 60 * 24;

    // Calculating the time difference between two dates
    const diffInTime = date2.getTime() - date1.getTime();

    // Calculating the no. of days between two dates
    const diffInDays = Math.round(diffInTime / oneDay);

    return diffInDays <= 365;
};
